import Aura from "@primeuix/themes/aura";
import { definePreset } from "@primeuix/themes";

// The default theme. In its own module (not main.ts) so stores can import it without importing
// the app entry point, which would create an import cycle (auth → entity → organizationConfig → main)
export const ThemePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "rgba(59, 130, 246, 0.05)",
      100: "rgba(59, 130, 246, 0.10)",
      200: "#3B82F6",
      300: "#3B82F6",
      400: "#3B82F6",
      500: "#3B82F6",
      600: "#3B82F6",
      700: "#3B82F6",
      800: "#3B82F6",
      900: "#3B82F6",
      950: "#3B82F6",
    },
    gray: {
      500: "#D1D5DB",
    },
  },
});
